var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-flex flex-center flex-align-center img-con",style:([_vm.basicStyle, _vm.addStyle])},[(_vm.rawSrc)?_c('img',{style:([_vm.imgStyle]),attrs:{"src":_vm.rawSrc}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }